<template>
<div class="sidebar">
   <div class="sidebar-overlay" v-bind:class="{ 'sidebar-overlay-active': sidebarOpen }" @click="toggle" ></div>
   <div class="sidebar-menu" v-bind:class="{ 'sidebar-menu-active': sidebarOpen }">
      <slot name="sidebar" ></slot>
      
      <el-menu default-active="-1" class="app-side-menu" :router="true">
         <el-menu-item index="/" class="">HOME</el-menu-item>

      <el-submenu index="a" class="">
          <template slot="title">INVITATION</template>
          <el-menu-item index="/loadpage/invitation/president-invitation" class="font-color-e">President’s Invitation</el-menu-item>
          <el-menu-item index="/loadpage/invitation/society-invitation" class="font-color-e">Society Invitation</el-menu-item>
      </el-submenu>

      <li class="el-menu-item"><a href="https://hotel.kenes.com/en/congress/EUROMED19"  target="_blank">HOTELS</a></li>

      <!--
          <el-menu-item index="/loadpage/comitati/comitati" class="">LOGO</el-menu-item>
      -->
      <el-submenu index="b" class="">
          <template slot="title">PROGRAMME</template>
          <!-- <li class="el-menu-item"><a :href="'/2019/documenti/WeekAgenda.pdf?random='+$teras.random()"  target="_blank">Week Agenda</a></li> -->
          <el-menu-item index="/loadpage/programme/week-agenda" class="font-color-e">Week Agenda</el-menu-item> 
          <!-- <li class="el-menu-item"><a href="http://bvent.biomedia.net/s/2132" target="_blank">Scientific Programme</a> </li> -->
          <el-menu-item index="/loadpage/programme/scientific-programme" class="font-color-e">Scientific Programme</el-menu-item>
          <!-- <el-menu-item index="/loadpage/programme/workshops" class="font-color-e">Educational Workshops</el-menu-item> -->
          <el-menu-item index="/educational-workshops" class="font-color-e">Educational Workshops</el-menu-item> 
          <!--
            <li class="el-menu-item"><a :href="'/2019/documenti/EducationalWorkshops.pdf?random='+$teras.random()"  target="_blank">Educational Workshops</a></li>
          -->
          <el-menu-item index="/loadpage/programme/satellite-meetings" class="font-color-e">Satellite Meetings</el-menu-item>
      </el-submenu>

      <el-menu-item index="/loadpage/abstracts/abstracts" class="">ABSTRACTS</el-menu-item>

      <el-submenu index="c" class="">
          <template slot="title">REGISTRATIONS</template>
          <el-menu-item index="/loadpage/registrations/registrations" class="font-color-e">Registration</el-menu-item>
          <el-menu-item index="/loadpage/registrations/bursary" class="font-color-e">EFLM Bursary Programme</el-menu-item>
          <el-menu-item index="/loadpage/registrations/scholarship" class="font-color-e">IFCC Travel Scholarships</el-menu-item>
          <el-menu-item index="/loadpage/registrations/awards" class="font-color-e">Awards</el-menu-item>
      </el-submenu>

      <!-- <el-menu-item index="/loadpage/sponsor/sponsor" class="">SPONSOR</el-menu-item> -->

      <el-submenu index="sponsor" class="">
          <template slot="title">SPONSOR</template>
          <el-menu-item index="/loadpage/sponsor/sponsor" class="">Sponsor</el-menu-item>
          <el-menu-item index="/loadpage/sponsor/mediapartner" class="">Media Partners</el-menu-item>
      </el-submenu>

      <el-submenu index="d" class="">
          <template slot="title">INFO</template>
          <el-menu-item index="/loadpage/info/organising-secretariat" class="font-color-e">Organising Secretariat</el-menu-item>
          <el-menu-item index="/loadpage/info/congress-venue" class="font-color-e">Congress Venue</el-menu-item>
          <el-menu-item index="/loadpage/info/general-information" class="font-color-e">General Information</el-menu-item>
          <el-menu-item index="/loadpage/committees/committees" class="font-color-e">Committees</el-menu-item>
          <el-menu-item index="/loadpage/info/newsletters" class="font-color-e">Newsletters</el-menu-item>
          <!-- <el-menu-item index="/loadpage/info/logo" class="font-color-e">Logo</el-menu-item> -->
      </el-submenu>

      </el-menu>

      <slot name="footer" v-if="false">Se non <b>passo</b> del testo</slot>
   </div>
</div>
</template>

<script>


export default {
  name: 'sidebar',
  data() {
    return {
      sidebarOpen: false
    }
  },
  created(){
    this.$teras.event.on('sidebarToggle', this.toggle)
    this.$teras.event.on('sidebarClose', this.close)
    this.$teras.event.on('routerChange', this.close)
  },
  methods:{
    close(){
      this.sidebarOpen = false
    },
    toggle () {
      this.sidebarOpen = !this.sidebarOpen
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.sidebar-overlay{
  position:fixed;
  z-index: 1000;
  height: 100vh;
  width: 100vw;
  left:-100vw;
  background: #ffffff;
  opacity: 0;
  transition-duration: .4s;
}.sidebar-overlay-active{
  opacity: 0.7;
  left:0;
}.sidebar-menu{
  z-index: 1000;
  top:0;
  position:fixed;
  height: 100vh;
  width: 0;
  background:#3E69B9;
  transition-duration: .4s;
  overflow:auto;
  padding-top:40px;
}#app.device-iOS .sidebar-menu{
  padding-top:60px !important;
}.sidebar-menu .el-menu{
  border:none !important;

}.sidebar-menu-active{
  width: 280px;
}.app-side-menu{
  padding-top:16px;
  background: transparent !important;
}.app-side-menu .el-menu-item, .app-side-menu  .el-submenu__title{
  color:#ffffff;
  font-size: 1.8rem;
  height: 46px;
  line-height: 46px;
}.app-side-menu .el-menu-item.is-active{
  color:#ffffff;
}.app-side-menu .el-submenu .el-menu-item:hover,.app-side-menu  .el-submenu__title:hover{
  color:#ffffff;
}.app-side-menu .el-submenu .el-menu li{
  color:#424F5C;
  line-height: initial;
  padding: 10px 0;
}.app-side-menu .el-submenu .el-menu li i{
  position:fixed;
  left: 15px;
  margin:2px 0 0 0;
  display:none;
}.app-side-menu .el-menu-item .material-icons, .app-side-menu .el-submenu__title  .material-icons{

  margin-right: 10px;
  vertical-align: baseline;
}.app-side-menu .el-submenu .el-menu{
  background: #b5f29f;
  color:#3E69B9 !important;
}.el-submenu .el-menu-item:hover, .el-submenu__title:hover{
  background-color: #b5f29f !important;
  color:#3E69B9 !important;


}.app-side-menu .el-submenu .el-menu li.double{
  color:#424F5C;
  height:auto;
  
}.app-side-menu .el-submenu .el-menu li.double .more{
  font-style: italic;
  font-size:1.6rem;
}
</style>
